import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';

import { AxiosResponse } from 'axios';
import store from '@/store';
import { t } from '@/i18n/i18n';
import * as api from '../api';

@Module({
	namespaced: true,
	name: 'analytics',
	store,
	dynamic: true
})
class AnalyticsModule extends VuexModule {
	chartData = {} as any;

	@Mutation
	setChartData(response: any): void {
		this.chartData = response;
	}

	@Action({ commit: `setChartData`, rawError: true })
	async getChartData(form: any): Promise<any> {
		try {
			const response: AxiosResponse = await api.getChartData(form);

			if (!(response as any).results) {
				// eslint-disable-next-line no-throw-literal
				throw {
					title: t('general.no-data'),
					body: t('general.no-data-found-for-selected-date-range')
				};
			}

			return response as any;
		} catch (error) {
			// @ts-ignore
			if (error.error) {
				// eslint-disable-next-line no-throw-literal
				throw {
					// @ts-ignore
					title: `Error ${error.error.code}`,
					body: t('general.something-went-wrong-try-again-later')
				};
			} else {
				throw error;
			}
		}
	}
}

export default getModule(AnalyticsModule);
